import CheckItemSelector from './src/main';

/* istanbul ignore next */
CheckItemSelector.install = function(Vue) {
  Vue.component(CheckItemSelector.name, CheckItemSelector);
};

export default CheckItemSelector;
